export default function formatArguments<T extends Record<string, any>>(args: T): string {
  return (
    '?' +
    Object.entries(args)
      .map(([key, value]) => {
        if (Array.isArray(value)) {
          return `${key}=${value.map((v) => encodeURIComponent(v?.toString() ?? '')).join(',')}`;
        }
        return `${key}=${encodeURIComponent(value?.toString() ?? '')}`;
      })
      .join('&')
  );
}
